// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-tab-games--grouped {
  padding-bottom: 8px;
}

.lotus-casino-tab-games--grouped .lotus-casino-lobby-group:last-child {
  margin-bottom: 0;
}

.lotus-casino-tab-games__title {
  height: 42px;
  display: flex;
  align-items: center;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  text-transform: capitalize;
  padding: 0 4px;
  margin-bottom: 12px;
}

.lotus-casino-tab-games__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px 12px;
  width: 100%;
}

.lotus-casino-tab-games__grid .lotus-casino-card--compact {
  width: 100%;
  min-width: 0;
}

.lotus-casino-tab-games__skeleton {
  width: 100%;
  aspect-ratio: 245 / 153;
  border-radius: 8px;
  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);
  background-size: 200% 100%;
  animation: lotus-tab-games-shimmer 1.2s infinite;
}

.lotus-casino-tab-games__empty {
  grid-column: 1 / -1;
  padding: 32px 4px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
}

@keyframes lotus-tab-games-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 900px) {
  .lotus-casino-tab-games__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* Mobile: always 3 columns for non-lobby tabs */
@media (max-width: 1119px) {
  .lotus-casino-tab-games {
    padding: 0 0 12px;
  }

  .lotus-casino-tab-games__title {
    padding: 5px 8px;
    font-size: 18px;
  }

  .lotus-casino-tab-games__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px 8px;
    padding: 0 8px;
    box-sizing: border-box;
  }
}

@media (max-width: 560px) {
  .lotus-casino-tab-games__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoTabGames/LotusCasinoTabGames.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gDAAgD;IAChD,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".lotus-casino-tab-games--grouped {\n  padding-bottom: 8px;\n}\n\n.lotus-casino-tab-games--grouped .lotus-casino-lobby-group:last-child {\n  margin-bottom: 0;\n}\n\n.lotus-casino-tab-games__title {\n  height: 42px;\n  display: flex;\n  align-items: center;\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: capitalize;\n  padding: 0 4px;\n  margin-bottom: 12px;\n}\n\n.lotus-casino-tab-games__grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 16px 12px;\n  width: 100%;\n}\n\n.lotus-casino-tab-games__grid .lotus-casino-card--compact {\n  width: 100%;\n  min-width: 0;\n}\n\n.lotus-casino-tab-games__skeleton {\n  width: 100%;\n  aspect-ratio: 245 / 153;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);\n  background-size: 200% 100%;\n  animation: lotus-tab-games-shimmer 1.2s infinite;\n}\n\n.lotus-casino-tab-games__empty {\n  grid-column: 1 / -1;\n  padding: 32px 4px;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 14px;\n}\n\n@keyframes lotus-tab-games-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@media (max-width: 900px) {\n  .lotus-casino-tab-games__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* Mobile: always 3 columns for non-lobby tabs */\n@media (max-width: 1119px) {\n  .lotus-casino-tab-games {\n    padding: 0 0 12px;\n  }\n\n  .lotus-casino-tab-games__title {\n    padding: 5px 8px;\n    font-size: 18px;\n  }\n\n  .lotus-casino-tab-games__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px 8px;\n    padding: 0 8px;\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 560px) {\n  .lotus-casino-tab-games__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
